'use client'

import { useState } from 'react'

import type { ICarRankingItem, TRankingCriteria } from '../_types'

/** 기본 정렬 기준 — 만족도 */
export const DEFAULT_RANKING_CRITERIA: TRankingCriteria = 'satisfaction'

export type TRankingMap = Record<TRankingCriteria, ICarRankingItem[]>

/**
 * 차종 랭킹 상태 — 선택 기준 + 기준별 TOP5.
 * rankingMap은 서버(page.tsx)에서 API 실데이터로 채워 내려준다 (목업 폴백 없음).
 */
export const useCarRanking = (rankingMap: TRankingMap) => {
  const [criteria, setCriteria] = useState<TRankingCriteria>(
    DEFAULT_RANKING_CRITERIA
  )
  const items = rankingMap[criteria]

  return { criteria, items, selectCriteria: setCriteria }
}
